import { SvgIcon, type SvgIconProps } from './svgIcon'

export function ErrorIcon({ width = 24, height = 24, ...props }: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <rect width="24" height="24" rx="12" fill="#121212" />
      <path
        d="M16.5 16.5L7.5 7.5M16.5 7.5L7.5 16.5"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  )
}
